import React, { FunctionComponent } from "react";

import { bemClassNames } from "@multiweb/reactUtils";
import { LOC_LEADS_FROM_ACTIVITY, LOC_LEADS_TO_ACTIVITY, LOC_TRANSITION_FROM_ACTIVITY_NOT_EXISTS, LOC_TRANSITION_TO_ACTIVITY_NOT_EXISTS, LOC_TRANSITIONS_LEADING_FROM_ACTIVITY, LOC_TRANSITIONS_LEADING_TO_ACTIVITY } from "../../../../locKeys";
import { UiWorkflow } from "../../../../UiWorkflow";
import { ActivityTransitionsList } from "../../components";
import { getTransitionsFromActivity, getTransitionsToActivity } from "./utils";

export type TransitionsFromToTabProps = {
    readonly activityId: string;
    readonly uiWorkflow: UiWorkflow;
};

const classNames = bemClassNames("transitions-from-to-tab-component");
const transitionsFromToTab = classNames();

export const TransitionsFromToTab: FunctionComponent<TransitionsFromToTabProps> = ({ uiWorkflow, activityId }) => {
    const transitionsToActivity = getTransitionsToActivity(activityId, uiWorkflow.workflow);
    const transitionsFromActivity = getTransitionsFromActivity(activityId, uiWorkflow.workflow);

    return (
        <div className={transitionsFromToTab}>
            <ActivityTransitionsList
                activityTransitions={transitionsToActivity}
                headerLocKey={LOC_TRANSITIONS_LEADING_TO_ACTIVITY}
                leadingLocKey={LOC_LEADS_FROM_ACTIVITY}
                fallbackTextLocKey={LOC_TRANSITION_TO_ACTIVITY_NOT_EXISTS} />
            <ActivityTransitionsList
                activityTransitions={transitionsFromActivity}
                headerLocKey={LOC_TRANSITIONS_LEADING_FROM_ACTIVITY}
                leadingLocKey={LOC_LEADS_TO_ACTIVITY}
                fallbackTextLocKey={LOC_TRANSITION_FROM_ACTIVITY_NOT_EXISTS} />
        </div>
    );
};
